import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserKeys } from "src/constants/userDetails";

export interface QuoteCustomization {
    quoteUuid: string;
    textColor: string | null;
    textFont: string | null;
    textAlign: string | null;
    verticalAlign: string | null;
    fontSize: number | null;
}

export interface QuoteArticle {
    uuid: string;
    title: string;
    articleHtml: string;
    imageUrl: string | null;
    referenceLinks: string[] | null;
    deleted_at: string | null;
    quoteImageUrl?: string | null;
    companyUuid?: string | null;
}

export interface CompanyQuote {
    uuid: string;
    quoteText: string | null;
    publishDate: string;
    isFreeContent: boolean;
    companyUuid: string;
    quoteCategories: string[];
    favourite: boolean;
    author?: string;
    imageUrl?: string;
    thumbnailUrl?: string;
    article?: QuoteArticle;
    customization?: QuoteCustomization;
}

function headers(): { Authorization: string } {
    return { Authorization: `Bearer ${localStorage.getItem(UserKeys.TOKEN)}` };
}

export async function getCompanyQuotes(signal: AbortSignal): Promise<CompanyQuote[]> {
    const response = await axios.get<{ premiumQuotes: CompanyQuote[] }>(`${API_URL}/quotes/companyQuotes`,
        { headers: headers(), signal });
    return response.data.premiumQuotes;
}

export async function getQuoteArticle(uuid: string, signal: AbortSignal): Promise<QuoteArticle | undefined> {
    const response = await axios.get<{ articles: QuoteArticle[] }>(
        `${API_URL}/quotes/articles/byUuids/${encodeURIComponent(JSON.stringify([uuid]))}`,
        { headers: headers(), signal });
    return response.data.articles.find(article => article.uuid === uuid && !article.deleted_at);
}
